import { request } from '@/fetch/core';
interface DataTag {
  tagId: number;
  parentId: number;
  tagName: string;
  tagType: string;
  count: number;
}
// 需求管理接口请求类
export class RequirementApi {
  /**
   * 获取需求列表
   * @param params 查询参数
   * @returns Promise<需求列表响应>
   */
  async getRequirementPageList(params: {
    pageNum: number;
    pageSize: number;
    description?: string;
    createUser?: string;
    status?: string;
    startTime?: string;
    endTime?: string;
  }) {
    return request({
      path: '/monitor/web/data-collection/getRequirementPageList',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: params,
    });
  }

  /**
   * 创建需求
   * @param data 需求数据
   * @returns Promise<创建响应>
   */
  async createRequirement(data: {
    relatedTags: Array<DataTag>;
    description: string;
    requiredDetail: string;
    forbiddenDetail: string;
  }) {
    return request({
      path: '/monitor/web/data-collection/addRequirement',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    });
  }

  /**
   * 更新需求
   * @param data 需求数据
   * @returns Promise<创建响应>
   */
  async editRequirement(data: {
    requirementId: number;
    disableTagIdList?: Array<number>;
    relatedTags: Array<DataTag>;
    description: string;
    requiredDetail: string;
    forbiddenDetail: string;
  }) {
    return request({
      path: '/monitor/web/data-collection/editRequirement',
      method: 'POST',
      body: data,
    });
  }

  /**
   * 更新需求状态
   * @param requirementId 需求ID
   * @param actionType 操作类型
   * @returns Promise<更新响应>
   */
  async updateRequirementStatus(
    requirementId: number,
    actionType: 'OPEN' | 'CLOSE'
  ) {
    return request({
      path: '/monitor/web/data-collection/changeRequirementState',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: {
        requirementId,
        actionType,
      },
    });
  }

  /**
   * 获取标签列表
   * @returns Promise<标签列表响应>
   */
  async getTagList() {
    return request({
      path: '/monitor/web/data-collection/getTagList',
      method: 'POST',
    });
  }

  /**
   * 新增标签
   * @param tagName 标签名
   * @returns Promise<新增响应>
   */
  async addTag(tagName: string) {
    return request({
      path: '/monitor/web/data-collection/addTag',
      method: 'POST',
      body: {
        tagName,
      },
    });
  }

  /**
   * 获取需求详情
   * @param requirementId 需求ID
   * @returns Promise<需求详情响应>
   */
  async getRequirementDetail(requirementId: number | string) {
    return request({
      path: '/monitor/web/data-collection/getTaskDetail',
      method: 'POST',
      body: { requirementId },
    });
  }

  async getPageCollectionTask(params: {
    startTime: string;
    endTime: string;
    pageNum: number;
    pageSize: number;
  }) {
    return request({
      path: '/monitor/web/data-collection/getPageCollectionTask',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 获取质检任务详情
   * @param collectionTaskId 采集任务ID
   * @returns Promise<采集任务详情响应>
   */
  async getCollectionTaskDetail(collectionTaskId: number | string) {
    return request({
      path: '/monitor/web/data-collection/getCollectionTaskDetail',
      method: 'POST',
      body: { collectionTaskId },
    });
  }

  /**
   * 查看场景详情
   * @param sceneId 场景ID
   * @returns Promise<场景详情响应>
   */
  async getTaskSceneDetail(sceneId: number | string) {
    return request({
      path: '/monitor/web/data-collection/getTaskSceneDetail',
      method: 'POST',
      body: { sceneId },
    });
  }

  /**
   * 删除场景关联标签
   * @param sceneId 场景ID
   * @param tagId 标签id
   * @returns Promise<响应>
   */
  async deleteSceneTag(sceneId: number | string, tagId: number) {
    return request({
      path: '/monitor/web/data-collection/deleteSceneTag',
      method: 'POST',
      body: { sceneId, tagId },
    });
  }

  /**
   * 获取场景匹配需求列表
   * @param sceneId 场景ID
   * @returns Promise<响应>
   */
  async getMatchedRequirementList(sceneId: number | string) {
    return request({
      path: '/monitor/web/data-collection/getMatchedRequirementList',
      method: 'POST',
      body: { sceneId },
    });
  }

  /**
   * 模糊查询需求列表
   * @param startTime 开始时间 必填，默认最近一年
   * @param endTime 结束时间 必填，默认最近一年
   * @param description 需求说明 模糊搜索
   * @returns Promise<响应>
   */
  async getRequirementList(params: {
    startTime: string;
    endTime: string;
    description: string;
  }) {
    return request({
      path: '/monitor/web/data-collection/getRequirementList',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 模糊查询需求列表
   * @returns Promise<响应>
   */
  async getVideoUrl(params: {
    id: number | string;
    type: string; // 'scene'
  }) {
    return request({
      path: '/shadow/web/video/view',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 完成质检
   * @returns Promise<响应>
   */
  async completeSceneTask(sceneId: number | string) {
    return request({
      path: '/monitor/web/data-collection/completeSceneTask',
      method: 'POST',
      body: { sceneId },
    });
  }

  /**
   * 关联场景和需求
   * @returns Promise<响应>
   */
  async associateSceneAndRequirement(params: {
    sceneId: number | string;
    requirementId: number | string;
    linked: boolean;
  }) {
    return request({
      path: '/monitor/web/data-collection/associateSceneAndRequirement',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 新增场景关联标签
   * @returns Promise<响应>
   */
  async addSceneTag(params: { sceneId: number | string; tagId: number[] }) {
    return request({
      path: '/monitor/web/data-collection/addSceneTag',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 手动查询增加关联需求显示列表
   * @returns Promise<响应>
   */
  async addMatchedRequirement(params: {
    sceneId: number | string;
    requirementId: number | string;
  }) {
    return request({
      path: '/monitor/web/data-collection/addMatchedRequirement',
      method: 'POST',
      body: params,
    });
  }

  /**
   * 分页获取需求关联场景列表
   * @returns Promise<响应>
   */
  async getRequirementScenePageList(params: {
    pageNum: number;
    pageSize: number;
    requirementId: number | string;
  }) {
    return request({
      path: '/monitor/web/data-collection/getRequirementScenePageList',
      method: 'POST',
      body: params,
    });
  }
}

// 导出实例
export const requirementApi = new RequirementApi();
export default requirementApi;
